module.exports = __webpack_public_path__ + "static/media/bb.cc9ed18e.svg";